<template>
  <button
    :data-field="externalKey"
    class="button"
    @click.prevent="clickHandler"
  >
    {{ text }}
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ControlButton',
  props: {
    text: {
      type: String,
      default: 'Button'
    },
    externalKey: {
      type: String,
      default: ''
    },
    externalHandler: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    clickHandler() {
      this.externalHandler();
    }
  }
};
</script>

<style lang="scss" scoped>

.button {
  cursor: pointer;
  border: none;
  color: $color-black;
  font-family: $font-family-medium;

  &--primary {
    text-transform: uppercase;
    min-width: calcEm(270px);
    max-width: calcEm(370px);
    width: 100%;
    height: calcEm(60px);
    line-height: calcEm(60px);
    font-size: calcEm(16px);
    background-color: $color-yellow;

    @include transitionBase(all);

    &:hover {
      color: $color-yellow;
      background-color: $color-black;
    }
  }

  &--text {
    text-transform: none;
    min-width: calcEm(270px);
    max-width: calcEm(370px);
    width: 100%;
    height: calcEm(60px);
    line-height: calcEm(60px);
    text-align: left;

    @include transitionBase(all);
  }
}
</style>
